/*
 * Check the status of feature flags
 */
export const isFeatureEnabled = (feature: string): boolean => {
  const upperFeature = feature.toUpperCase();

  if (_COMPILE_TIME_FEATURES.has(upperFeature)) {
    return ['ON', '1'].some((e) => e === import.meta.env[_COMPILE_TIME_PREFIX + _FLAG_PREFIX + upperFeature]);
  }

  console.warn(`Unknown feature '${upperFeature}'`);
  return false;
};

/*
 * Compile time feature flags
 *
 * These should generally be set in .env as "VITE_FEATURE_FLAG_...=ON"
 */
const _COMPILE_TIME_FEATURES: Map<string, string> = new Map([
  ['DISABLE_AUTHENTICATION', 'Disables authentication and uses a fixed user for all backend communications'],
  ['REAL_TIME_CAPTIONING', 'Enables access to Real Time Captioning (RTC) features.'],
  ['REAL_TIME_CAPTIONING_PREVIEW', 'Enable HLS preview stream for Real Time Captioning'],
  ['REAL_TIME_CAPTIONING_BROADCAST_OVERWRITE', 'Add an overwrite switch to RTC broadcast create form.'],
  ['FAVICON_RECORDING_ICON', 'Enable the favicon recording icon'],
]);

const _COMPILE_TIME_PREFIX = 'VITE_';
const _FLAG_PREFIX = 'FEATURE_FLAG_';
